'use client';

import React from 'react';

import { ProgramDefaultListItemLayout } from '@/app/[locale]/(default-layout)/program/_components/ProgramDefaultListItemLayout';
import { ProgramMobileListItemLayout } from '@/app/[locale]/(default-layout)/program/_components/ProgramMobileListItemLayout';

import { HrefOrHrefWithParams } from 'next-intl/dist/types/navigation/shared/utils';

import { CachedContentData } from '@/hooks/useCachedContentData';
import useShowingsListFiltered from '@/hooks/useShowingsListFiltered';

import MobileOrDesktopRendererSSR from '@cineamo/composables/src/MobileOrDesktopRendererSSR';

type ShowingListItemProps = {
    content: CachedContentData;
    selectedDate?: string | 'all';
};

export default function ShowingListItem(props: ShowingListItemProps) {
    const { content, selectedDate } = props;

    const link: HrefOrHrefWithParams<'/program/[contentId]'> = {
        pathname: '/program/[contentId]',
        params: {
            contentId: content.id
        }
    };

    const { totalItems } = useShowingsListFiltered({
        contentId: content.id,
        selectedDate: selectedDate
    });

    // CSS-toggled (both layouts in the SSR HTML, wrong breakpoint hidden via media query) instead of
    // the JS renderer: a JS mount-swap paints the SSR-chosen layout first and only switches after
    // hydration, which flashed the desktop row on mobile as new rows entered on scroll.
    return (
        <MobileOrDesktopRendererSSR
            desktopContent={
                <ProgramDefaultListItemLayout
                    selectedDate={selectedDate}
                    href={link}
                    content={content}
                    totalItems={totalItems}
                />
            }
            mobileContent={
                <ProgramMobileListItemLayout
                    href={link}
                    content={content}
                    totalItems={totalItems}
                    selectedDate={selectedDate}
                />
            }
        />
    );
}
